import { Injectable } from '@angular/core';
import { APISCockpit } from 'src/service/apis-cockpit';
import { Menu } from '../contextapplication/models/menu';

@Injectable({ providedIn: 'root' })

export class MenuService {

  menus: Menu[] = new Array<Menu>();

  constructor(private apiCockpit: APISCockpit) { }

  async HavePermission(tagmenu: string, securityId: number, companyId: number): Promise<boolean> {
    let retorno = false;
    await this.GetInfoMenu(tagmenu, securityId, companyId).then( ret => retorno = ret.length > 0);
    return retorno;
  }

  async GetInfoMenu(tagmenu: string, securityId: number, companyId: number): Promise<Menu[]> {

    let url: string = this.getAPIMenuPermission();

    if (tagmenu && tagmenu !== '') {
      url += `/${tagmenu}`;
    }

    let concat = '?';
    if (securityId && securityId > 0) {
      url += concat + `&$filter=tagMenu eq '${securityId}'`;
      concat = '';
    }

    if (companyId && companyId > 0) {
      url += concat + `&companyId=${companyId}`;
    }

    await this.apiCockpit.getDataInfoObservable(url).toPromise()
    .then(result => this.menus = result['menuItems']);

    return this.menus;
  }

  getAPIMenuPermission() {
    return `/api/framework/v1/menus`;
  }
}
